import { render } from "./ExternalRedirect.vue?vue&type=template&id=3fb21193&scoped=true"
import script from "./ExternalRedirect.vue?vue&type=script&lang=js"
export * from "./ExternalRedirect.vue?vue&type=script&lang=js"

import "./ExternalRedirect.vue?vue&type=style&index=0&id=3fb21193&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb21193"]])

export default __exports__